<template>
    <article
        class="plugin-map _full"
        v-bind:class="{ _show: show }"
    >
        <slot />
    </article>
</template>

<script>
export default {
    name: 'plugin-map-full',
    data: () => ({
        show: false,
    }),
    mounted() {
        this.show = true;
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-map {
    /deep/ iframe {
        display: none;
    }
    &._show {
        /deep/ iframe {
            display: block !important;
        }
    }

    position: relative;

    display: block;
    width: 100%;
    height: 368px;
    border-radius: 10px;
    overflow: hidden;

    filter: grayscale(1);

    &._full {
        height: 100%;
        border-radius: 0;
    }
    iframe {
        width: 100% !important;
        height: 100% !important;
    }
}
</style>
